
const MostrarDetalles = () => {
  let $mostrarMas = document.querySelectorAll('.combo__detalles__button');
  Array.from($mostrarMas).forEach((item) => {
    item.addEventListener('click', (event) => {
      const $comboDetalles = event.target.parentNode;
      if ($comboDetalles.classList.contains('--activo')) {
        $comboDetalles.classList.remove('--activo');
        event.target.innerHTML = "Mostrar detalles";
      } else {
        $comboDetalles.classList.add('--activo');
        event.target.innerHTML = "Ocultar detalles";
      }
    });
  });
};


module.exports = {
  init: () => {
    MostrarDetalles();
  }
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/comboCard.js